import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/top.png';
import _imports_1 from '@/assets/images/top-bule.png';
import _imports_2 from '@/assets/images/bom.png';

const _withScopeId = n => (_pushScopeId("data-v-70b13f27"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "menu-title"
};
const _hoisted_2 = {
  ref: "containerRef",
  class: "tab-list-wrapper"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "item-info"
};
const _hoisted_5 = {
  key: 0,
  class: "item-name"
};
const _hoisted_6 = {
  key: 0,
  class: "icon",
  src: _imports_0,
  alt: ""
};
const _hoisted_7 = {
  key: 1,
  class: "icon",
  src: _imports_1,
  alt: ""
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  key: 1
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_14 = [_hoisted_13];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menu-item", {
      'menu-item-last': $props.isLast
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString($props.menuData.title), 1)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    ref: "tabListRef",
    class: _normalizeClass(["tab-list", {
      'tab-list-expanded': $data.expandStatus === 1
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menuList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab-item", {
        'tab-item-checked': $props.checkedId == item.id,
        'tab-item-unchecked': $props.checkedId != item.id
      }]),
      onClick: $event => $options.checkedChange(item)
    }, [_createElementVNode("div", _hoisted_4, [item.children && item.children.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createTextVNode(_toDisplayString(item.name) + " ", 1), $props.checkedId != item.id ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : (_openBlock(), _createElementBlock("img", _hoisted_7))])) : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.name), 1))])], 10, _hoisted_3);
  }), 256))], 2)], 512), $options.showExpandBtn ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.expand && $options.expand(...args)),
    class: "expand-btn"
  }, [$data.expandStatus === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)) : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))])) : _createCommentVNode("", true)], 2);
}